import { Report, ShortRecipient } from '@apps/rept/domain/models';
import { TemplateVersion } from '@apps/rept/rept.constants';

export class UpdateReportApi
{
    reportId: string;
    version: TemplateVersion;
    cultureName: string;
    externalRecipients: ShortRecipient[];
    internalRecipients: string[];

    public static mapperToApi (source: Report): UpdateReportApi
    {
        const target = new UpdateReportApi();

        target.reportId = source.reportId;
        target.version = source.version;
        target.cultureName = source.cultureName;
        target.internalRecipients = [...source.internalRecipients];
        target.externalRecipients = [...source.externalRecipients];

        return target;
    }
}
